import React from 'react'
import TextButton from './textButton'

const RecoveryPasswordLink = ({
  icon,
  title,
  subtitle,
  content,
  boldText,
  tag,
  message,
  onClick,
  counter,
  disabled
}) => (
  <div className='flex flex-col w-full items-center'>
    {icon}

    <div className='px-5 flex flex-col items-center'>
      <h1 className='font-manrope font-bold text-2xl leading-6 text-black mt-6 text-center '>
        {title}
        <br />
        {subtitle}
      </h1>
      <p className='font-manrope font-medium font-base leading-6 text-gray-900 text-center my-6 sm:px-16 lg:px-0'>
        {content} <span className='text-black font-bold'>{boldText}</span>{' '}
      </p>

      <div className='bg-red-900 text-white text-xs font-medium px-2 rounded-sm'>
        {tag}
      </div>
    </div>

    <div className='flex w-full flex-col justify-center text-center mt-6'>
      <div className='text-center flex justify-center items-center flex-col'>
        {counter ? (
          <>
            <span className='text-xs font-semibold text-black px-5 py-1 rounded-sm'>
              {message}
            </span>
            <p className=' text-xs font-medium mt-2'>
              Podrás reenviarlo dentro de <strong>{counter} </strong>
              segundos
            </p>
          </>
        ) : (
          <>
            <span className='font-manrope font-medium text-black leading-5 opacity-80'>
              ¿No te llegó el mensaje?
            </span>
            <TextButton
              handleFunction={() => {
                onClick()
              }}
              hasIcon
              className={`py-1 text-purple-900 ${disabled || ''}`}
              isDisabled={disabled}
            >
              Reenviar
            </TextButton>
          </>
        )}
        {/* Se comenta este botón hasta tener más definición sobre la elección del método de verificación */}
        {/* <TextButton className='font-manrope font-medium text-purple-900 leading-5 opacity-50 mt-5'
          hasIconLeft
          handleFunction={() => ''} >Elegir otro metodo de verificación</TextButton> */}
      </div>
    </div>
  </div>
)

export default RecoveryPasswordLink
